<template>
  <div :style="{ padding: padding }">
    <table style="border-collapse: collapse;" :style="{ width: center ? 'auto' : '100%' }">
      <tr>
        <td style="padding-right: 12px;" v-if="icon !== ''">
          <img :src="icon" :width="width" :height="height" />
        </td>
        <td :style="{ fontWeight: fontWeight, fontSize: fontSize, color: color }" v-html="title"></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'LayoutBlockTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    padding: {
      type: String,
      default: '16px',
    },
    fontWeight: {
      type: Number,
      default: 700,
    },
    fontSize: {
      type: String,
      default: '14px',
    },
    color: {
      type: String,
      default: '#000000',
    },
    center: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style>
.radar_count {
  font-size: 24px;
  font-weight: 700;
}
.radar_good {
  color: #059347;
}
.radar_bad {
  color: #ca2a1d;
}
.radar_none {
  font-weight: 700;
}
</style>
